/** ロゴのペンダントランプ。lit で電球が灯る */
export function LampMark({ size = 28, lit = true }: { size?: number; lit?: boolean }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="lamp-mark">
      <path d="M16 1v9" stroke="currentColor" strokeWidth="1.2" />
      <path d="M7 19c0-5 4-9 9-9s9 4 9 9z" fill="currentColor" />
      <circle cx="16" cy="21.5" r="3.6" fill={lit ? 'var(--filament)' : 'var(--ink-3)'} />
      {lit && <circle cx="16" cy="21.5" r="9" fill="var(--tungsten)" opacity=".2" />}
    </svg>
  )
}
